<script>
  import IoIosClose from 'svelte-icons/io/IoIosClose.svelte';
  export let title;
  export let texto;
  export let paragrafo;
  export let glossarioBegin;
  export let glossarioEnd;
  export let idUnico = 'glossario';
  // export let parCount;

  let ativo = false;
  function abrir() {
    ativo = true;
  }
  $: cssVarStyles = `--id:${idUnico};`;
</script>

<div id={idUnico} class="dialog-container {ativo ? 'active' : ''}">
  <div
    id={idUnico + '-bkg'}
    class="background {ativo ? 'active' : ''}"
    on:click={() => (ativo = false)}
  />
  <div id={idUnico + '-dialog'} class="dialog">
    <div id={idUnico + '-ilustracao'} class="ilustracao">
      <img src="./assets/images/icons/glossario.svg" alt="" />
    </div>
    <div class="botao-fechar" on:click={() => (ativo = false)}>
      <IoIosClose />
    </div>
    <div class="title">
      <span class="verbete"
        ><slot name="titulo" />{title.charAt(0).toUpperCase() + title.slice(1)}</span
      >
    </div>
    <div class="text">
      <p>
        <!-- <span class="verbete"><slot name="titulo" />:</span> -->
        {@html texto}
        {#if false}
          {@html texto}
        {/if}
      </p>
    </div>
  </div>
</div>

<div id={idUnico + '-strong'} class="container">
  {@html paragrafo.substring(0, glossarioBegin)}

  <strong on:click={abrir}>{title}</strong>{@html paragrafo.substring(
    glossarioEnd + '{{/glossario}}'.length,
    paragrafo.length
  )}
  <!-- <div class="par-count dev-mode-block">{parCount}</div> -->
</div>

<style>
  /* width */
  ::-webkit-scrollbar {
    width: 5px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: rgba(0, 0, 0, 0);
    right: 5px;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: rgb(172, 110, 110);
    background: var(--COR_MOD_TER_POD_1);
    border-radius: 10px;
    padding: 5px 0;
  }
  strong {
    color: #fff;
    cursor: pointer;
    font-weight: 700;
    background: var(--MARROM);
  }
  strong:hover {
    font-weight: 700;
  }
  .ilustracao {
    position: absolute;
    top: -15px;
    right: 80px;
    height: 50px;
    width: 50px;
  }
  .ilustracao svg {
    z-index: 2001;
  }

  .background,
  .dialog-container {
    visibility: hidden;
    position: fixed;
    left: 0;
    width: 100%;
    height: calc(100% + 50px);
    opacity: 0;
  }
  .background {
    top: 0;
    background: rgba(0, 0, 0, 0.308);
  }
  .dialog-container {
    top: 80px;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1900;
    transition: all 300ms ease;
  }
  .background.active,
  .dialog-container.active {
    visibility: visible;
    opacity: 1;
  }
  .dialog-container.active {
    /* transform: translateY(calc(-50% - 50px)); */
    transform: translateY(calc(-50% - 0px));
    top: 50%;
  }
  .dialog {
    width: 60vw;
    max-width: 36em;
    max-height: 90vh;
    padding: 25px;
    position: relative;
    z-index: 2000;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.1);
    background: var(--MARROM_SUPER_CLARO);
    border-top: 5px solid var(--MARROM);
    border-bottom-left-radius: 9.88px;
    border-bottom-right-radius: 9.88px;
  }

  .dialog .title {
    display: flex;
    padding: 5px 20px;
    position: relative;
    justify-content: left;
    font-style: normal;
    font-size: 22px;
  }
  .dialog .text {
    padding: 0px 20px;
    font-family: var(--FONT_LORA);
    position: relative;
    overflow-y: scroll;
    overflow-x: hidden;
    max-height: calc(90vh - 100px);
    font-style: normal;
  }
  .dialog .text p {
    font-family: var(--FONT_LORA);
    font-size: 18px;
    margin-bottom: 0 !important;
  }
  .verbete {
    font-weight: 700;
    font-family: var(--FONT_LORA);
    color: var(--MARROM);
    margin-top: 1.5rem;
  }
  .botao-fechar {
    width: 50px;
    cursor: pointer;
    color: var(--MARROM);
    position: absolute;
    right: 0;
    top: 0;
  }

  @media (max-width: 767px) {
    .dialog {
      width: 90vw;
    }
    .dialog .text {
      padding-bottom: 20px;
      max-height: calc(90vh - 120px);
    }
  }
</style>
